<template>
	<div>
		Register
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>